module.exports = __webpack_public_path__ + "img/delete.66537341.svg";